import {ButtonBase, IconButton} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {FormattedMessage} from "react-intl";
import Space from "./Space";
import React from "react";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import {
  SECTION_HEADER_BOTTOM_SPACE,
  SECTION_HEADER_WITH_SUBTITLE_BOTTOM_SPACE
} from "src/js/components/commons/SectionHeaderView";

const FormSectionHeaderView = ({classes, section, onToggle}) => {
  const onClick = () => {
    onToggle(section);
  };
  const disabled = true; // section.expandAlways || (section.expand && section.noCollapse);
  const disabledButton = true; // section.expandAlways || (section.expand && section.noCollapse);
  return (
    <div className={classes.expandCollapseBar}>
      <ButtonBase disabled={disabled} className={classes.buttonBaseApp} style={{marginBottom: section.subLabelId ? SECTION_HEADER_WITH_SUBTITLE_BOTTOM_SPACE : SECTION_HEADER_BOTTOM_SPACE}} onClick={onClick}>
        <div className={classes.flexRow}>
          <div className={classes.viewColumnFullWidthNoCenter}>
            <div className={classes.flexRow}>
              <Typography variant={'body1'} color={'textPrimary'} align={'left'} className={classes.typoMedium}>
                {section.labelId ?
                  <FormattedMessage id={section.labelId} />
                  : section.label
                }
              </Typography>
            </div>
            {/*{section.subLabelId ?*/}
            {/*  <Typography color={'textSecondary'} variant={'caption'} align={'left'} className={classes.typoNormal} style={{marginTop: -10, marginBottom: 8}}>*/}
            {/*    <FormattedMessage id={section.subLabelId} />*/}
            {/*  </Typography>*/}
            {/*  : null*/}
            {/*}*/}
          </div>
          <Space vertical={16} />
        </div>
      </ButtonBase>
      {!disabledButton ?
        <IconButton onClick={onClick}>
          {section.expand ? <RemoveCircleOutlineIcon /> : <AddCircleOutlineIcon />}
        </IconButton>
        : null
      }
    </div>
  );
};

export default FormSectionHeaderView;
